<script>
export default {
  name: "HeartLike",
  props: ['count'],
  emits: ["like"],
  data() {
    return {
      hearts: [],
      isThrottled: false // 用于控制节流
    };
  },
  methods: {
    addLike() {
      if (this.isThrottled) {
        return; // 如果处于节流状态，直接返回
      }
      this.$emit("like");
      // 设置节流状态
      this.isThrottled = true;
      const colors = ['#ff5a5f', '#ffb6c1', '#fa8072'];

      // 生成一个爱心
      const heart = {
        style: {
          top: '0px',
          left: '0px',
          color: colors[Math.floor(Math.random() * colors.length)],
          transform: `translate(${Math.random() * 100 - 50}px, ${Math.random() * -150 - 50}px)`,
          opacity: 1,
        }
      };
      // 将新爱心添加到 hearts 列表中
      this.hearts.push(heart);

      // 在1秒后移除爱心
      setTimeout(() => {
        this.hearts.shift();
        this.isThrottled = false;
      }, 1000);
    },
  }
};
</script>

<template>
  <div class="like-container">
    <div class="flex flex-col space-y-1 items-center">
      <svg class="icon" height="100%" p-id="1492" t="1729222129080" version="1.1" viewBox="0 0 1024 1024" width="100%" xmlns="http://www.w3.org/2000/svg" @click="addLike"><path d="M944.4 147.9C838.4 43 666.6 43 560.6 147.8l-48.1 47.6-49.2-48.7c-106-104.9-277.8-104.9-383.8 0s-106 275 0 379.9L512.6 955.1l431.9-427.4c105.9-104.9 105.9-274.9-0.1-379.8z" fill="#FF0000" p-id="1493"></path></svg>
      <span class="text-sm">{{ count }}</span>
    </div>

    <div v-for="(heart, index) in hearts" :key="index" :style="heart.style" class="heart">
      <van-icon name="like" />
    </div>
  </div>
</template>


<style scoped>
.like-container {
  position: relative;
  display: inline-block;
  color: #FFF;
}

.heart {
  position: absolute;
  font-size: 1rem;
  animation: fly 1s ease-out forwards;
}

@keyframes fly {
  0% {
    opacity: 1;
    transform: translate(0, 0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50px, -150px) scale(2);
  }
}

.icon {
  width: 1.875rem;
  height: 1.875rem;
}

</style>
